import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import * as pdfMake from 'pdfmake/build/pdfmake';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiHandlerService } from 'src/app/View/handlers/api-handler.service';
import { SharedService } from 'src/app/View/service/shared.service';
import { environment } from 'src/environments/environment';
import { DecimalPipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class TsmaeReportsService {

  constructor(private datePipe: DatePipe,
    private sharedService: SharedService,
    private api: ApiHandlerService,
    private decimalPipe: DecimalPipe) {
  }

  public pieChartData: BehaviorSubject<any> = new BehaviorSubject<any>({});
  //public graphData: Observable<any> = this.pieChartData.asObservable();

  getInitialData(): Observable<any> {
    return this.api.post(environment.apiUrl + '/tsmAeReportInitialDataLoad', {});
  }

  getTsmAeReport(data: any): Observable<any> {
    return this.api.post(environment.apiUrl + '/tsmAeReport', data);
  }

  setPieChartData(data){
    this.pieChartData.next(data);
  }

  getPieChartData():Observable<any>{
    return this.pieChartData.asObservable();
  }  

  oilField = ['sampledDate', 'esn', 'sampleId', 'flagStatus', 'engineMiles', 'oilMiles', 'oxidation', 'nitration', 'soot',
      'fuelDilution', 'tan', 'tbn', 'vis40', 'vis100', 'water'];
  metalField = ['sampledDate', 'esn', 'sampleId', 'flagStatus', 'fe', 'cu', 'pb', 'cr', 'al', 'k', 'na', 'ca', 'sn', 'zn', 'mg',
      'p', 'b', 'mo', 'si', 'mn', 'ag', 'ba', 'bi', 'in', 'ni']; 

  oilMetalField  = ['sampledDate', 'esn', 'sampleId', 'flagStatus', 'engineMiles', 'oilMiles', 'oxidation', 'nitration', 'soot',
      'fuelDilution', 'tan', 'tbn', 'vis40', 'vis100', 'water', 'fe', 'cu', 'pb', 'cr', 'al', 'k', 'na', 'ca', 'sn', 'zn', 'mg',
      'p', 'b', 'mo', 'si', 'mn', 'ag', 'ba', 'bi', 'in', 'ni'];  

  oilHeaderPdf = [{fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Sampled Date'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'ESN'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Sample Id'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Flag Status'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Unit Distance'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Fluid Distance'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Oxidation (abs/cm)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Nitration (abs/cm)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Soot (%)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Fuel Dilution (%)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Acid Number (mgKOH/g)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'TBN (mgKOH/g)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'VIS40 (cSt)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'VIS100 (cSt)'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Water (ppm)'}];        
  
  metalHeaderPdf = [{fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Sampled Date'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'ESN'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Sample Id'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Flag Status'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Fe'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Cu'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Pb'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Cr'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Al'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'K'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Na'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Ca'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Sn'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Zn'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Mg'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'P'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'B'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Mo'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Si'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Mn'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Ag'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Ba'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Bi'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'In'},
      {fillColor: '#000000', color: '#FFFFFF', borderColor:['#ffffff', '#ffffff', '#ffffff', '#ffffff'], bold: true, alignment: 'center', text: 'Ni'}];
  
  metalTitlePdf =[{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'All Metal Information (ppm) for Units with Key Issue Flags greater than Normal',colSpan:25 },
      '','','','','','','','','','','','','','','','','','','','','','','','' ];   
  oilTitlePdf =[{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Oil Health for Units with Key Issue Flags greater than Normal',colSpan:15 },
      '','','','','','','','','','','','','','' ];  
      
  oilHeaderExcel = ['Sampled Date', 'ESN', 'Sample Id', 'Flag Status', 'Unit Distance', 'Fluid Distance', 'Oxidation (abs/cm)', 'Nitration (abs/cm)', 'Soot (%)', 'Fuel Dilution (%)', 'Acid Number (mgKOH/g)', 'TBN (mgKOH/g)', 'VIS40 (cSt)', 'VIS100 (cSt)',  'Water (ppm)', 'Fe', 'Cu', 'Pb', 'Cr', 'Al', 'K', 'Na', 'Ca', 'Sn', 'Zn', 'Mg', 'P', 'B', 'Mo', 'Si', 'Mn', 'Ag', 'Ba', 'Bi', 'In', 'Ni'];
  //metalHeaderExcel = ['Sampled Date', 'ESN', 'Sample Id', 'Flag Status', 'Fe', 'Cu', 'Pb', 'Cr', 'Al', 'K', 'Na', 'Ca', 'Sn', 'Zn', 'Mg', 'P', 'B', 'Mo', 'Si', 'Mn', 'Ag', 'Ba', 'Bi', 'In', 'Ni'];    
  
  
  generateExcel(inputData) {
    inputData.oilHealthList = this.convertToDecimalOil(inputData.oilHealthList, this.oilField);
    inputData.metalList = this.convertToDecimalMetal(inputData.metalList, this.metalField);

    //merge Oil and metal list
    inputData = this.mergeOilAndMetalList(inputData);    

    let severityMap = {'Normal':'1', 'Watch':'2', 'Caution':'3', 'Warning':'4'};
    
    //Excel Title, Header, Data
    const title = 'TSM/AE Report';

    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('TSM-AE Report');
    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Calibri', family: 4, size: 16, underline: 'none', bold: true }
    worksheet.addRow([]);

    //Report detail section
    //Sample Date Range
    let reportGenereatedDetailsRow = worksheet.addRow(['Report Generated Details']);
    this.setReportDetailHeaderStyle(worksheet,reportGenereatedDetailsRow);
    let generatedBy = worksheet.addRow(['Generated By', this.sharedService.getUserId()]);
    this.setBorder(generatedBy);
    let generatedDate = worksheet.addRow(['Generated Date', this.datePipe.transform(new Date(), 'medium')]);
    this.setBorder(generatedDate);

    //Sample Date Range
    let sampleDateRangeRow = worksheet.addRow(['Sample Date Range']);
    this.setReportDetailHeaderStyle(worksheet,sampleDateRangeRow);
    let startDateRow = worksheet.addRow(['Start Date', inputData.startDate]);
    this.setBorder(startDateRow);
    let endDateRow = worksheet.addRow(['End Date', inputData.endDate]);
    this.setBorder(endDateRow);

    //customer and unit information
    let customerInfo = worksheet.addRow(['Customer & Unit Information']);
    this.setReportDetailHeaderStyle(worksheet,customerInfo);
    let companyIdRow = worksheet.addRow(['Company Id', inputData.companyId]);
    this.setBorder(companyIdRow);
    let companyNameRow = worksheet.addRow(['Company Name', inputData.companyName]);
    this.setBorder(companyNameRow);
    let customerNameRow = worksheet.addRow(['Customer Name', inputData.customerName]);
    this.setBorder(customerNameRow);
    let phoneNumberRow = worksheet.addRow(['Phone Number', inputData.customerPhone]);
    this.setBorder(phoneNumberRow);

    //Fleet statics
    let fleetStatisticsRow = worksheet.addRow(['Fleet Statistics']);
    this.setReportDetailHeaderStyle(worksheet,fleetStatisticsRow);
    let engineModelRow = worksheet.addRow(['Engine Model', inputData.engineModel]);
    this.setBorder(engineModelRow);
    let numberOfEngineRow = worksheet.addRow(['# Engines in FluidWatch® fleet by Model', inputData.engineCountByModel]);
    this.setBorder(numberOfEngineRow);
    let countOfUnitsRow = worksheet.addRow(['Count Of Units', inputData.countOfUnits]);
    this.setBorder(countOfUnitsRow);
    let countOfSamplesRow = worksheet.addRow(['Count of Samples', inputData.countOfSamples]);
    this.setBorder(countOfSamplesRow);
    
    //Oil
    worksheet.addRow([]);
    worksheet.addRow([]);
    let oilTitle = worksheet.addRow(['Oil Health/All Metal Information (ppm) for Units with Key Issue Flags greater than Normal']);
    oilTitle.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    oilTitle.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'AA696969' }
    };    
    //oilTitle.getCell(1).alignment = {horizontal: 'center'};
    oilTitle.getCell(1).font = {color:{argb: "FFFFFFFF"}, bold: true};
    //Merge Cells
    worksheet.mergeCells(`A${oilTitle.number}:AJ${oilTitle.number}`);
    //Add Header Row
    let oilHeaderRow = worksheet.addRow(this.oilHeaderExcel);    
    // Header style
    oilHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00000000' },
        bgColor: { argb: '00000000' }
      };
      cell.alignment = {horizontal: 'center'};
      cell.font = {color:{argb: "FFFFFFFF"}, bold: true};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    //Add Oil Data
    inputData.oilHealthList.forEach((row) => {
      let rowData = [];
      this.oilMetalField.forEach((field) => {
        if(field == 'sampledDate' || field == 'esn' || field == 'sampleId' || field == 'flagStatus'){
          rowData.push(row[field]);
        }else if(field == 'engineMiles' || field == 'oilMiles'){
          rowData.push(+row[field].replace(',',''));
        }else{
          if(row[field].value == null){
            rowData.push('');
          }else{
            rowData.push(+row[field].value.replace(',',''));
          }          
        }        
      });
      let excelRow = worksheet.addRow(rowData);
      excelRow.eachCell((cell, number) => { 
        //conditional formatting for severity   
        if(number > 6){
          let severity = 0;
          severity = +row[this.oilMetalField[number-1]].severity;          
          this.getSeverityFillColor(severity, cell);
        }
        //formatting for Flag status
        if(number == 4){
          let severity = 0;
          severity = severityMap[row[this.oilMetalField[number-1]]];          
          this.getSeverityFillColor(severity, cell);
        }
          
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });

    //Metals
    /*worksheet.addRow([]);
    worksheet.addRow([]);
    let metalTitle = worksheet.addRow(['All Metal Information (ppm) for Units with Key Issue Flags greater than Normal']);
    metalTitle.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    metalTitle.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'AA696969' }
    };    
    //metalTitle.getCell(1).alignment = {horizontal: 'center'};
    metalTitle.getCell(1).font = {color:{argb: "FFFFFFFF"}, bold: true};
    //Merge Cells
    worksheet.mergeCells(`A${metalTitle.number}:Y${metalTitle.number}`);
    //Add Header Row
    let metalHeaderRow = worksheet.addRow(this.metalHeaderExcel);    
    // Header style
    metalHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00000000' },
        bgColor: { argb: '00000000' }
      }
      cell.alignment = {horizontal: 'center'};
      cell.font = {color:{argb: "FFFFFFFF"}, bold: true}
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    //Add Metal Data
    inputData.metalList.forEach((row) => {
      let rowData = [];
      this.metalField.forEach((field) => {
        if(field == 'sampledDate' || field == 'esn' || field == 'sampleId' || field == 'flagStatus'){
          rowData.push(row[field]);
        }else{
          rowData.push(+row[field].value.replace(',',''));
        }        
      });
      let excelRow = worksheet.addRow(rowData);
      excelRow.eachCell((cell, number) => {   
        //conditional formatting for severity   
        if(number > 4){
          let severity = 0;
          severity = +row[this.metalField[number-1]].severity;          
          this.getSeverityFillColor(severity, cell);
        }

        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });*/

    
    worksheet.getColumn(1).width = 35;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 15;
    worksheet.getColumn(5).width = 15;
    worksheet.getColumn(6).width = 15;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 15;
    worksheet.getColumn(10).width = 15;
    worksheet.getColumn(11).width = 15;
    worksheet.getColumn(12).width = 15;
    worksheet.getColumn(13).width = 15;
    worksheet.getColumn(14).width = 15;
    worksheet.getColumn(15).width = 15;
    worksheet.getColumn(16).width = 15;
    worksheet.getColumn(17).width = 15;
    worksheet.getColumn(18).width = 15;
    worksheet.getColumn(19).width = 15;
    worksheet.getColumn(20).width = 15;
    worksheet.getColumn(21).width = 15;
    worksheet.getColumn(22).width = 15;
    worksheet.getColumn(23).width = 15;
    worksheet.getColumn(24).width = 15;
    worksheet.getColumn(25).width = 15;

   
    worksheet.addRow([]);
        
    
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'TSM/AE Report.xlsx');
    })
  }

  setReportDetailHeaderStyle(worksheet,tagName){
    worksheet.mergeCells(`A${tagName.number}:B${tagName.number}`);
    tagName.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    tagName.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'AA696969' }
    };    
    tagName.getCell(1).alignment = {horizontal: 'center'};
    tagName.getCell(1).font = {color:{argb: "FFFFFFFF"}, bold: true};
  }

  setBorder(tagName){
    tagName.eachCell((cell, number) => { 
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
  }

  getSeverityFillColor(severity, cell){
    if(severity == 2){
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF8E71C' },
        bgColor: { argb: 'FFF8E71C' }
      };          
    }else if(severity == 3){
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF19806' },
        bgColor: { argb: 'FFF19806' }
      };  
    }else if(severity == 4){
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDA291C' },
        bgColor: { argb: 'FFDA291C' }
      };  
    }  
  }

  mergeOilAndMetalList(inputData):any{
    inputData.oilHealthList.forEach(oil=>{
      inputData.metalList.forEach(metal=>{
        if(metal.sampleId == oil.sampleId){
          oil = Object.assign(oil, metal);
        }
      });
    });
    return inputData;
  }

  downloadPDF(imageData, fileName, inputData){
    inputData.oilHealthList = this.convertToDecimalOil(inputData.oilHealthList, this.oilField);
    inputData.metalList = this.convertToDecimalMetal(inputData.metalList, this.metalField);
    this.export(imageData, fileName, inputData); 
  }

  async export(imageData, fileName, inputData){  
    let document = {      
      /*pageSize: {
        width: 595.28,
        height: 'auto'
      },*/
      pageSize:'A4',
      pageOrientation: 'landscape',
      pageMargins: [40, 40, 40, 70],
      header: function(currentPage, pageCount, pageSize) {
          
        return [
          { text: 'TSM/AE Report', 
          border: [true, true, true, true], margin: [40, 10, 0, 0],
              style: 'headerExample',
          },{ canvas: [{ type: 'line', x1: 40, y1: 0, x2: 800, y2: 0, lineWidth: 0.5, lineColor:'teal' }] }
        ]
      },
      footer: function(currentPage, pageCount) { 
        return {
          columns: [{
            table: {
              body: [
                [{ text: 'Page ' + currentPage.toString() + ' of ' + pageCount, margin: [40, 20, 0, 0], border: [true, true, true, true], fontSize: 6, style: 'footerExample' }, {}],

                [
                  {
                    image: 'data:image/png;base64,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',
                    width: 30,
                    margin: [40, 0, 40, 0]
                  }, { fontSize: 6, margin: [0, 0, 40, 0], text: "Disclaimer: All information including recommended actions are provided on an “as is” basis.  No warranty is expressed or implied. Cummins expressly disclaims any and all warranties and liability arising from or otherwise related to information provided herein.  See the Marketplace Terms and Conditions of Use for more details regarding such disclaimers. \n FluidWatch® \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t fluidwatch.laboratory@cummins.com", alignment: 'justify' }

                ]]
            }, layout: 'noBorders'
          }]
        };
      },
      content: [
                
        {
          image: imageData,
          width: 760,  
          height: 509,        
          margin: [0, -8, 0, 0]
        },       
       
        this.tableForOil(inputData.oilHealthList, this.oilField, this.oilHeaderPdf, this.oilTitlePdf),
        this.tableForMetal(inputData.metalList, this.metalField, this.metalHeaderPdf, this.metalTitlePdf)
      ],

      styles: {        
        graphContent: {
          fontSize: 8,
          bold: true
        },headerExample: {
          fontSize: 16,
          bold: true,
          width:'600 px'
        },footerExample: {
          fontSize: 8,
          bold: true
        },tableContentMetal: {
          fontSize: 6.33,
          alignment: 'center',
          border: true
        }
      }

    };
    pdfMake.createPdf(document).download(fileName);
  }  

  tableForMetal(data, columns, headers, title) {
    return {
      border: [false, false, false, false], 
      margin: [0, 10, 0, 0],
      style: 'tableContentMetal',
      //pageBreak: "before",
      table: {
        //widths:[500],
        //width: 500,
        //widths: [ 30, 30, 45, 30, 8 ,8, 8, 8, 8, 8 ,8, 8, 8, 8, 8 ,8, 8, 8, 8, 8 ,8, 8, 8, 8, 8 ],
        //widths: [ '*', '*','*','*','*','*', '*','*','*','*','*', '*','*','*','*','*', '*','*','*','*','*', '*','*','*','*' ],
        //widths: [ 'auto', 'auto','auto','auto','auto','auto', 'auto','auto','auto','auto','auto', 'auto','auto','auto','auto','auto', 'auto','auto','auto','auto','auto', 'auto','auto','auto','auto' ],
        widths: [ '8%', '8%','9%','8%','3%','3%', '3%','3%','3%','3%','3%', '4%','3%','4%','4%','4%', '3%','3%','3%','3%','3%', '3%','3%','3%','3%' ],
        headerRows: 2,
        body: this.buildTableBody(data, columns, headers, title),

      },
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
        },
        vLineWidth: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
        },
        hLineColor: function (i, node) {
          return 'lightGray';
        },
        vLineColor: function (i, node) {
          return 'lightGray';
        }
      }
    };
  }

  tableForOil(data, columns, headers, title) {
    return {
      border: [false, false, false, false], margin: [0, 0, 0, 0],
      style: 'tableContentMetal',
      pageBreak: "before",
      table: {        
        //widths: [ 'auto', 'auto','auto','auto','auto','auto', 'auto','auto','auto','auto','auto', 'auto','auto','auto','auto' ],
        //widths: [ '*', '*','*','*','*','*', '*','*','*','*','*', '*','*','*','*' ],
        widths: [ '7%', '8%','8%','6%','7%','7%', '7%','7%','6%','6%','6%','6%','6%','6%','7%' ],
        headerRows: 2,
        body: this.buildTableBody(data, columns, headers, title),

      },
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
        },
        vLineWidth: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
        },
        hLineColor: function (i, node) {
          return 'lightGray';
        },
        vLineColor: function (i, node) {
          return 'lightGray';
        }
      }
    };
  }  

  buildTableBody(data, columns, headers, title) {
    var body = [];
    let severityMap = {'Normal':'1', 'Watch':'2', 'Caution':'3', 'Warning':'4'};
    body.push(title);     
    body.push(headers);
    data.forEach(function (row) {
      var dataRow = [];
      columns.forEach(function (column) {
        var severity = ''; 
        var text = ''; 
        if(column == 'sampledDate' || column == 'esn' || column == 'sampleId' || column == 'flagStatus' || column == 'engineMiles' || column == 'oilMiles'){
          text = row[column].toString();
          severity = '';
          if(column == 'flagStatus'){
            severity = severityMap[row[column].toString()];
          }
        }else{
          text = String(row[column].value);
          severity = String(row[column].severity);

          if(text == 'null'){
            text = '';
          }
          if(severity == 'null'){
            severity = '';
          }
        }        
        
        var sevColor = '';
        if (severity == '2') {
          sevColor = '#F8E71C';
        }
        if (severity == '3') {
          sevColor = '#F19806';
        }
        if (severity == '4') {
          sevColor = '#DA291C';
        }
        dataRow.push({ fillColor: sevColor, text: text,borderColor:['#000000', '#000000', '#000000', '#000000'] });        
      });
      body.push(dataRow);
    });
    return body;
  }

  convertToDecimalOil(inputData, columns):any{
    inputData.forEach(row=>{
      columns.forEach(column=>{
        if(column == 'engineMiles' || column == 'oilMiles'){
          row[column] = this.decimalPipe.transform(row[column].toString());          
        }else if(column == 'oxidation' || column == 'nitration' || column == 'soot' || column == 'tan' || column == 'tbn' || column == 'vis40' || column == 'vis100'){
          row[column].value = this.decimalPipe.transform(row[column].value.toString(), '1.2-2'); 
        }else if(column == 'fuelDilution'){
          row[column].value = this.decimalPipe.transform(row[column].value.toString(), '1.1-1'); 
        }else if(column == 'water'){
          row[column].value = this.decimalPipe.transform(row[column].value.toString());          
        }
      });
    });
    return inputData;
  }

  convertToDecimalMetal(inputData, columns):any{
    inputData.forEach(row=>{
      columns.forEach(column=>{
        if(column != 'sampledDate' && column != 'esn' && column != 'sampleId' && column != 'flagStatus'){
          row[column].value = this.decimalPipe.transform(row[column].value.toString());          
        }
      });
    });
    return inputData;
  }

}
